export const APP_AUTH_TRACKING_EVENT = "app-auth";
